//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "FloatImgBtn",
  props:{
    text:{
      type:String,
      default:"默认文字"
    },
    itemWidth:{
      type:Number,
      default:100
    },
    itemHeight:{
      type:Number,
      default:100
    },
    gapWidth:{
      type:Number,
      default:10
    },
    coefficientHeight:{
      type:Number,
      default:0.6
    },
    imgsrc:{
      type:String,
      default:""
    }
  },
  created(){
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = this.clientWidth - this.itemWidth - this.gapWidth;
    this.top = this.clientHeight*this.coefficientHeight;
  },
  mounted(){
    window.addEventListener('scroll', this.handleScrollStart);
    this.$nextTick(()=>{
      const div = this.$refs.div;
      div.addEventListener("touchstart",()=>{
        div.style.transition = 'none';
      });
      div.addEventListener("touchmove",(e)=>{
        if (e.targetTouches.length === 1) {
          let touch = event.targetTouches[0];
          this.left = touch.clientX - this.itemWidth/2;
          this.top = touch.clientY - this.itemHeight/2;
        }
      });
      div.addEventListener("touchend",()=>{
        div.style.transition = 'all 0.3s';
         if(this.left>this.clientWidth/2){
           this.left = this.clientWidth - this.itemWidth - this.gapWidth;
         }else{
           this.left = this.gapWidth;
         }
      });

    });
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.handleScrollStart);
  },
  methods:{
    onBtnClicked(){
      this.$emit("onFloatBtnClicked");
    },
    handleScrollStart(){
      this.timer&&clearTimeout(this.timer);
      this.timer = setTimeout(()=>{
        this.handleScrollEnd();
      },300);
      this.currentTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(this.left>this.clientWidth/2){
        this.left = this.clientWidth - this.itemWidth/2;
      }else{
        this.left = -this.itemWidth/2;
      }
    },
    handleScrollEnd(){
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop === this.currentTop){
        if(this.left>this.clientWidth/2){
          this.left = this.clientWidth - this.itemWidth - this.gapWidth;
        }else{
          this.left = this.gapWidth;
        }
        clearTimeout(this.timer);
      }
    }
  },
  data(){
    return{
      timer:null,
      currentTop:0,
      clientWidth:0,
      clientHeight:0,
      left:0,
      top:0,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FloatImgBtn.vue